module.exports = __webpack_public_path__ + "img/neumaticos.c308de87.jpg";